import http from '@/components/services/http-common';

export const getResign = (isExpire) => {
  return http.get("contracts/resign", {
  params: {
    expire: isExpire
  }
  }).then(r => r.data)
}